/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const storeAnalyticsEventsDataSchema = z.object({
	events: z.array(
		z.object({
			app: z.string(),
			entityType: z.string(),
			entityId: z.string().uuid(),
			sessionId: z.string().uuid(),
			eventType: z.string(),
			metadata: z.record(z.string(), z.unknown()).nullable().optional(),
			timestamp: z.string().nullable().optional(),
		}),
	),
})

export type StoreAnalyticsEventsDataSchema = z.infer<typeof storeAnalyticsEventsDataSchema>
